export default __webpack_public_path__ + "static/media/3.bdecedc6.jpg";